import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  privacidade: {
    title: "Política de Privacidade",
    sections: [
      ["1. Responsável pelo tratamento", "PROALP22 — trabalhos de construção e em altura, Lisboa, Portugal. Contacto: proalp22construcao@gmail.com | +351 925 948 568."],
      ["2. Dados que recolhemos", "Através do formulário de contacto recolhemos: nome, telefone, email, serviço de interesse e mensagem. Estes dados são usados exclusivamente para responder ao seu pedido de orçamento."],
      ["3. Finalidade", "Os dados fornecidos servem apenas para: responder a pedidos de contacto, preparar orçamentos e comunicar sobre os nossos serviços. Não vendemos nem partilhamos os seus dados com terceiros para fins de marketing."],
      ["4. Conservação", "Os dados são conservados apenas durante o período necessário para dar resposta ao pedido e cumprir obrigações legais."],
      ["5. Os seus direitos (RGPD)", "Nos termos do RGPD, tem direito a aceder, retificar, apagar ou limitar o tratamento dos seus dados. Para exercer estes direitos, contacte-nos através de proalp22construcao@gmail.com."],
      ["6. Segurança", "Aplicamos medidas técnicas e organizativas adequadas para proteger os seus dados contra acesso não autorizado, perda ou divulgação."],
    ],
  },
  cookies: {
    title: "Política de Cookies",
    sections: [
      ["1. O que são cookies", "Cookies são pequenos ficheiros de texto guardados no seu dispositivo quando visita o nosso site."],
      ["2. Cookies que utilizamos", "Utilizamos cookies estritamente necessários ao funcionamento do site (por exemplo, para guardar o idioma escolhido) e cookies de análise anónimos que nos ajudam a melhorar o site."],
      ["3. Preferência de idioma", "Guardamos localmente a sua escolha de idioma (PT/RU/EN/FR) para que o site abra sempre no seu idioma. Esta informação não é partilhada."],
      ["4. Como gerir cookies", "Pode eliminar ou bloquear cookies nas definições do seu navegador. O bloqueio de cookies essenciais pode afetar o funcionamento de algumas partes do site."],
      ["5. Contacto", "Questões sobre cookies: proalp22construcao@gmail.com."],
    ],
  },
};

export default function LegalPage({ kind }) {
  const navigate = useNavigate();
  const c = CONTENT[kind];
  useEffect(() => {
    document.title = `PROALP22 — ${c.title}`;
    window.scrollTo(0, 0);
  }, [c.title]);
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid={`legal-${kind}`}>
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24">
        <button
          data-testid="legal-back"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-neutral-400 transition-colors hover:text-[#FF5A00]"
        >
          <ArrowLeft size={14} /> PROALP22
        </button>
        <img src="/logo.png" alt="PROALP22" className="mt-10 h-24 w-auto" />
        <h1 className="mt-8 font-display text-4xl md:text-5xl uppercase tracking-wide">{c.title}</h1>
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, p], i) => (
            <div key={i}>
              <h2 className="text-sm font-bold uppercase tracking-widest text-[#FF5A00]">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-neutral-300">{p}</p>
            </div>
          ))}
        </div>
        <p className="mt-14 border-t border-white/10 pt-6 text-xs text-neutral-500">
          Última atualização: agosto de 2026 · PROALP22 · Lisboa, Portugal
        </p>
      </div>
    </div>
  );
}
